import { NgModule } from "@angular/core";
// import { AngularFireModule } from "@angular/fire/compat";
import {
  AngularFireRemoteConfig
} from "@angular/fire/compat/remote-config";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";

import { InterpolatableTranslationObject, TranslateService } from "@ngx-translate/core";
// import { DeviceDetectorModule } from "ngx-device-detector";
// import { SWIPER_CONFIG, SwiperConfigInterface } from "ngx-swiper-wrapper";
import { LoadingService } from "@core/loading.service";
import { catchError, firstValueFrom } from "rxjs";
import { InitFactoryService } from "./services/init-factory.service";

// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
//   direction: "horizontal",
//   slidesPerView: "auto",
// };

// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, "assets/i18n/", ".json");
// }


@NgModule(/* TODO(standalone-migration): clean up removed NgModule class manually. 
{
    declarations: [AppComponent],
    imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({
        mode: "ios",
    }),
    IonicStorageModule.forRoot({
        name: "__mydb",
        driverOrder: ["sqlite", "websql", "indexeddb"],
        size: 100 * 1024 * 1024,
    }),
    CommonModule,
    AppRoutingModule,
    DirectiveModule,
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    StorePageModule,
    SyndicatePageModule,
    CheckWinningsModule,
    FirebaseModule,
    ComponentModule,
    // DeviceDetectorModule.forRoot(),
    ServiceWorkerModule.register("service-worker.js"),
    HttpClientModule,
    SalesModule,
    TooltipModule,
    CashoutModule,
    GamesPageModule,
    AngularFireStorageModule,
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: createTranslateLoader,
    //     deps: [HttpClient],
    //   },
    // }),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: FirestoreTranslationsLoaderFactory,
            deps: [HttpClient, AuthService],
        },
    }),
    [AngularFireModule.initializeApp(environment.firebase), AngularFireRemoteConfigModule],
    AgeVerificationPage,
    Fork1Page,
    Fork2Page,
    ForgotPasswordPage,
    VerifyFailedSmsPage,
    SignupPage,
    LoginPage,
    WelcomePage,
    SplashComponent,
    SetupCompleteComponent,
    AppUpdateComponent,
    HoldingScreenComponent,
    AccountCreatedComponent,
    FreeRegStep4dComponent,
    FreeRegStep4gComponent,
    FreeRegStep4bComponent,
    PreAuthpageComponent,
    FreeRegCompleteProfileComponent,
    SuccessfulPaymentComponent,
    PaymentPage,
    QuickLaunchComponent,
    StuckWebsiteComponent,
    VipStatusComponent,
    SliderManagerComponent,
    RedirectUriComponent,
    PartnerOfferComponent,
    PickOfferComponent,
],
    providers: [
        HttpClientModule,
        SwForceUpdateService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // { provide: SWIPER_CONFIG, useValue: DEFAULT_SWIPER_CONFIG },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        { provide: RollbarService, useFactory: rollbarFactory },
        { provide: Window, useValue: window },
        { provide: DEFAULTS, useValue: { enableAwesome: true } },
        {
            provide: SETTINGS,
            useFactory: () => isDevMode()
                ? {
                    minimumFetchIntervalMillis: 10000,
                    fetchTimeoutMillis: 15000,
                }
                : {},
        },
        {
            provide: SwRegistrationOptions,
            useFactory: () => ({ enabled: environment.production, registrationStrategy: "registerWhenStable:40000" }),
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppCheckInterceptor,
            multi: true,
        },
        ScreenOrientation,
        { provide: APP_INITIALIZER, useFactory: initializeAppCustomLogic, deps: [InitFactoryService], multi: true },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
    ],
    bootstrap: [AppComponent],
} */)
export class AppModule {
  loaderTimeout: NodeJS.Timeout;
  constructor(
    private remoteConfig: AngularFireRemoteConfig,
    private router: Router,
    private loadingService: LoadingService
  ) {
    this.remoteConfig.fetchAndActivate().catch((error) => {
      return error.message;
    });

    // logic to implement universal loader for page navigation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loaderTimeout = setTimeout(() => {
          this.loadingService.present();
        }, 250);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        clearTimeout(this.loaderTimeout);
        this.loadingService.dismiss();
      }
    });
  }
}

// Factory function: waits for translation loading to complete
export function appInitializerFactory(translateService: TranslateService): () => Promise<string | InterpolatableTranslationObject> {
  return () => {
    const savedLanguage = localStorage.getItem('language_code');
    const defaultLanguage = 'en';
    const languageToUse = savedLanguage || defaultLanguage;

    // Try to load the user's saved language
    return firstValueFrom(
      translateService.use(languageToUse).pipe(
        catchError(error => {
          console.error(`Failed to load language '${languageToUse}', falling back to '${defaultLanguage}'. Error:`, error);
          // Fallback to default language
          return translateService.use(defaultLanguage);
        })
      )
    );
  };
}

export function initializeAppCustomLogic(service: InitFactoryService): () => Promise<string> {
  // firstValueFrom resolves on the first emit — Angular APP_INITIALIZER waits for
  // Observables to *complete*, and getV2CloudFunction can emit without completing
  // (e.g. offline queue), which left the app stuck on the index.html Oops screen.
  return () => firstValueFrom(service.load());
}
// Register the service worker module 'service-worker.js' with specified configuration
ServiceWorkerModule.register("service-worker.js", {
  // Determine whether service worker is enabled based on conditions
  // Also guard against environments (e.g. Electron) where navigator.serviceWorker is undefined
  enabled: 'serviceWorker' in navigator && (
    !navigator.userAgent.toUpperCase().includes("LIKE MAC")
      ? true // If not Mac/iOS, set enabled to true
      : // Check if the user agent includes a known broken Safari version
      /Version\/(16\.[0-7]|17\.[01])/.test(navigator.userAgent)
        ? false // If so, set enabled to false
        : true  // Otherwise, set enabled to true
  ),
});
